import { useForm, observer } from "@formily/react";
import { Button } from "./Button";
import { Card } from "antd";

interface ImageCaptureSentCardProps {
  title: string;
  description: string;
  buttonText: string;
}

export const ImageCaptureSentCard = observer(
  (props: ImageCaptureSentCardProps) => {
    const form = useForm();

    const imageCaptureSent = form.getValuesIn("imageCaptureSent");
    if (!imageCaptureSent) {
      return null;
    }

    return (
      <Card title={props.title ?? "Afbeeldingen"} className="mb-4">
        <p className="text-gray-700">
          {props.description ??
            "Je hebt nog geen afbeeldingen toegevoegd. Door op de onderstaande knop te klikken, kun je direct afbeeldingen toevoegen. Let op dat wij de afbeeldingen nodig hebben om een herstelafspraak in te plannen."}
        </p>

        <Button
          type="primary"
          href={imageCaptureSent.fullSoleraLink}
          className="w-full mt-5"
          target="_blank"
          rel="noopener noreferrer"
        >
          {props.buttonText ?? "Afbeeldingen toevoegen"}
        </Button>
      </Card>
    );
  },
);
